import { Box, Typography } from '@mui/material/';
import React from 'react';
import NavBar from "../navigationBar";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import MobileNavBar from '../mobileNavigationBar';


const About = () => {
    return (
        <>
            <BrowserView><NavBar /></BrowserView>
            
            <Box m={4}>
                <Typography variant="h4" gutterBottom>
                    What is OnTime? Does it sync my clocks?
                </Typography>
                <Typography variant="body1" paragraph>
                    OnTime is a tool that helps people get to where they need to go on time.
                </Typography>

                <Typography variant="h4" gutterBottom>
                    What prompted the creation of OnTime?
                </Typography>
                <Typography variant="body1" paragraph>
                    It was the first day of winter quarter and there were two freshmen frantically trying to find
                    their classroom E101E. They approached me to ask if I knew where it was. I took an educated
                    guess and sent them into Baskin Engineering 1, but to be honest I was not 100% sure.
                    It was then that I realized providing indoor directions was something that could help people
                    and that I could totally make a project around this. It would not only be
                    beneficial to freshmen but even fourth years like myself. :P
                </Typography>

                <Typography variant="h4" gutterBottom>
                    Who is OnTime for?
                </Typography>
                <Typography variant="body1" paragraph>
                    OnTime is for anyone who is trying to get to a location within a building. Students, Guest
                    Lecturers, TA's, etc ...
                </Typography>

                <Typography variant="h4" gutterBottom>
                    What can OnTime do for me?
                </Typography>
                <Typography variant="body1" paragraph>
                    When you get to the building that your class is in. OnTime can display a route for you
                    that shows you the quickest route to your destination.
                </Typography>

                <Box mt={4}>
                    <Typography variant="h4" gutterBottom>
                        Who created OnTime?
                    </Typography>
                    <Typography variant="body1">
                        OnTime was created by a group of 6 developers from UC Santa Cruz:
                    </Typography>
                    <Typography variant="body1" component="ul">
                        <li>Joey Stratton</li>
                        <li>Josh McElroy</li>
                        <li>Mikayla Win</li>
                        <li>Vinish Dhir</li>
                        <li>Aveline Han Xiaoyuan</li>
                        <li>Dexter Zhang</li>
                    </Typography>
                </Box>
            </Box>
            <MobileView><MobileNavBar /></MobileView>

        </>
    );
}

export default About;
